module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Overseas Freight Consolidation")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard')], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search (Assignment No. / Client / Container No. / Shipping BL No / SHipping Invoice No / MBL / HBL )"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": "Select To"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.ToFilter),
      callback: function($$v) {
        _vm.ToFilter = $$v
      },
      expression: "ToFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllAgentDDList'],
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Agent"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.agentFilter),
      callback: function($$v) {
        _vm.agentFilter = $$v
      },
      expression: "agentFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("CLOSE STATUS")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.CLosedStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Close Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.closedFilter),
      callback: function($$v) {
        _vm.closedFilter = $$v
      },
      expression: "closedFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Incoterm")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Incoterm"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.termFilter),
      callback: function($$v) {
        _vm.termFilter = $$v
      },
      expression: "termFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("SOB FILTER")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.SOBFilter),
      callback: function($$v) {
        _vm.SOBFilter = $$v
      },
      expression: "SOBFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("MANIFESTATION STATUS")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ManifestationStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Manifestation"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.manifestationFilter),
      callback: function($$v) {
        _vm.manifestationFilter = $$v
      },
      expression: "manifestationFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.FFExport,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "ffFclConsoExportId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "ffExportFclConsoSeries",
      fn: function(row01) {
        return [_c('div', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              row01.item.is_locked == '1' &&
                (row01.item.finalBillingCompleted == 1 || row01.item.locked_counter > 0) ?
                '' :
                _vm.viewExportFCLConPage(row01.item.ffFclConsoExportId)
            }
          }
        }, [_c('span', [_vm._v("\n                Assignment No.: " + _vm._s(row01.item.ffExportFclConsoSeries) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Raised From: " + _vm._s(row01.item.EmpLoc) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Date : " + _vm._s(_vm._f("moment")(row01.item.loginTime)) + "\n                "), _c('br')]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": row01.item.is_locked == '1' &&
              (row01.item.finalBillingCompleted == 1 ||
                row01.item.locked_counter > 0) ?
              'danger' :
              'success'
          },
          on: {
            "click": function($event) {
              row01.item.is_locked == '1' &&
                (row01.item.finalBillingCompleted == 1 ||
                  row01.item.locked_counter > 0) ?
                _vm.LockUnLock(row01.item, 'locked') :
                ''
            }
          }
        }, [(
          row01.item.is_locked == '1' &&
          (row01.item.finalBillingCompleted == 1 ||
            row01.item.locked_counter > 0)
        ) ? _c('b', [_c('i', {
          staticClass: "fa fa-lock mr-1 lg"
        }), _vm._v("LOCKED\n                ")]) : _c('b', [_c('i', {
          staticClass: "fa fa-unlock mr-1 lg"
        }), _vm._v("UN-LOCKED ")])]), _vm._v(" "), _c('br'), _vm._v(" "), (row01.item.enquiry_booking_no) ? _c('span', [_vm._v("BRF No : " + _vm._s(row01.item.enquiry_booking_no)), _c('br')]) : _vm._e(), _vm._v(" "), (row01.item.inco_term) ? _c('span', [_vm._v("Inco Term : " + _vm._s(row01.item.inco_term)), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', {
          style: ('color:black')
        }, [_vm._v("Billing : ")]), _vm._v(" "), ((row01.item.finalBillingCompleted == '1')) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed")]) : (row01.item.finalBillingCompleted == '4') ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed - Agent Expense Pending")]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Billing In-complete")]), _c('br'), _vm._v(" "), (
          row01.item.sob_date_detected != '' &&
          row01.item.sob_date_detected != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("SOB : " + _vm._s(row01.item.sob_date_detected))]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("SAILED")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row01.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row01.item.allModuleId,
            "jb_series": row01.item.ffExportFclConsoSeries
          }
        }), _vm._v(" "), (row01.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row01.item.ffExportFclConsoSeries,
            "PMC_JOBID": row01.item.allModuleId,
            "PMC_JOBNO": row01.item.ffExportFclConsoSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e()]
      }
    }, {
      key: "clientName",
      fn: function(row112) {
        return [_vm._v(_vm._s(_vm.uniqueString(row112.item.clientName)))]
      }
    }, {
      key: "placeRecp",
      fn: function(row11) {
        return [_c('div', [_c('span', [_vm._v("\n                Agent Name : " + _vm._s(row11.item.agentName) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Shipping Line : " + _vm._s(row11.item.shippingLine) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                POR : " + _vm._s(row11.item.placeRecp) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Load Port : " + _vm._s(row11.item.LoadPort) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                POD : " + _vm._s(row11.item.placeDis) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                FPOD : " + _vm._s(row11.item.finalPlace) + "\n                "), _c('br')])])]
      }
    }, {
      key: "MBL",
      fn: function(row18) {
        return [_c('span', [_vm._v("\n              MBL NO.:- " + _vm._s(row18.item.master_linerBLNumber) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n              HBL NO.:- " + _vm._s(row18.item.house_BLNumber) + "\n              "), _c('br')]), _vm._v(" "), (row18.item.allContainer.length > 0) ? _c('span', [_c('b', [_vm._v("CONT NO.:-")]), _vm._v(" "), (row18.item.allContainer[0].fclConcontainerNo) ? _c('b', [_vm._v(_vm._s(_vm.wordWrap(row18.item.allContainer[0].fclConcontainerNo, 24)))]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (row18.item.containersTypes) ? _c('span', [_c('b', [_vm._v("CONT TYPE.:-")]), _vm._v(" "), (row18.item.containersTypes) ? _c('b', [_vm._v(_vm._s(_vm.wordWrap(row18.item.containersTypes, 24)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "action",
      fn: function(row3) {
        return [(row3.item.debitcount >= 1) ? _c('b-button', {
          attrs: {
            "disabled": row3.item.closedOverseas_status == 0 ? true : false,
            "size": "sm",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              row3.item.CountmainManifestationData > 0 ?
                _vm.openNoteModal(2, row3.item) :
                ''
            }
          }
        }, [_vm._v("Debit Note")]) : _vm._e(), _vm._v(" "), (row3.item.debitcount <= 0) ? _c('b-button', {
          attrs: {
            "disabled": row3.item.closedOverseas_status == 0 ? true : false,
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              row3.item.CountmainManifestationData > 0 ?
                _vm.openNoteModal(2, row3.item) :
                ''
            }
          }
        }, [_vm._v("Debit Note")]) : _vm._e(), _vm._v(" "), (row3.item.creditcount >= 1) ? _c('b-button', {
          staticClass: "mb-1",
          attrs: {
            "disabled": row3.item.closedOverseas_status == 0 ? true : false,
            "size": "sm",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              row3.item.CountmainManifestationData > 0 ?
                _vm.openNoteModal(1, row3.item) :
                ''
            }
          }
        }, [_vm._v("Credit Note")]) : _vm._e(), _vm._v(" "), (row3.item.creditcount <= 0) ? _c('b-button', {
          staticClass: "mb-1",
          attrs: {
            "disabled": row3.item.closedOverseas_status == 0 ? true : false,
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              row3.item.CountmainManifestationData > 0 ?
                _vm.openNoteModal(1, row3.item) :
                ''
            }
          }
        }, [_vm._v("Credit Note")]) : _vm._e(), _vm._v(" "), (!row3.item.preAlertDate) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.checkActions(row3.item)
            }
          }
        }, [_vm._v("Send Pre-Alert")]) : _c('div', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticClass: "p-2",
          attrs: {
            "variant": "success"
          }
        }, [_c('b', [_vm._v("PreAlert sent on " + _vm._s(row3.item.preAlertDate))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("by " + _vm._s(row3.item.preAlertRaisedBy))])])], 1), _vm._v(" "), (
          row3.item.frghtTermsMbl == 'Collect' &&
          row3.item.frghtTermsHbl == 'Collect' &&
          row3.item.closedOverseas_status == 1 &&
          row3.item.creditDebitNoteType != 1 &&
          row3.item.creditDebitNoteType != '' &&
          !_vm.checkcreditDebitNote_Status(row3.item.NoteDetails)
        ) ? _c('b-badge', {
          staticClass: "p-2 mb-1",
          attrs: {
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.checkActions(row3.item)
            }
          }
        }, [_c('b', [_vm._v("Credit Note Pending")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _vm._l((row3.item.NoteDetails), function(CDitem, CD_index) {
          return _c('span', {
            key: CD_index
          }, [(
            CDitem.uploadCreditDebit != '' &&
            CDitem.approvalStatus == '1' &&
            CDitem.creditDebitNoteType == '1'
          ) ? _c('b-badge', {
            staticClass: "p-2 ml-2 mb-1",
            attrs: {
              "variant": "warning",
              "creditNoteStatus": CDitem.creditDebitNote_Status,
              "size": "sm"
            },
            on: {
              "click": function($event) {
                _vm.PrintNote(
                  row3.item.ffExportFclConsoSeries,
                  CDitem.uploadCreditDebit
                )
              }
            }
          }, [(CDitem.creditDebitNoteType == '1') ? _c('span', [_vm._v("Credit Note PDF")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (
            CDitem.uploadCreditDebit != '' &&
            CDitem.approvalStatus == '1' &&
            CDitem.creditDebitNoteType == '2'
          ) ? _c('b-badge', {
            staticClass: "p-2 mb-1",
            attrs: {
              "variant": "warning",
              "size": "sm"
            },
            on: {
              "click": function($event) {
                _vm.PrintNote(
                  row3.item.ffExportFclConsoSeries,
                  CDitem.uploadCreditDebit
                )
              }
            }
          }, [(CDitem.creditDebitNoteType == '2') ? _c('span', [_vm._v("Debit Note")]) : _vm._e(), _vm._v("PDF\n                  "), _c('br')]) : _vm._e()], 1)
        }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-badge', {
          staticClass: "p-2 m-t-2",
          attrs: {
            "variant": "success"
          }
        }, [_c('b', [_vm._v("\n                  Debit / Credit Generated on\n                  " + _vm._s(row3.item.creditDebitTime) + "\n                ")]), _vm._v(" "), _c('br')])], 2), _vm._v(" "), _c('br'), _vm._v(" "), (row3.item.portLocationType == 'USA' && !row3.item.amsTime) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.checkActions(row3.item)
            }
          }
        }, [_vm._v("AMS Filed")]) : (row3.item.portLocationType == 'USA' && row3.item.amsTime) ? _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("\n              AMS on " + _vm._s(row3.item.amsTime) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.portLocationType == 'USA' && !row3.item.isfTime) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.checkActions(row3.item)
            }
          }
        }, [_vm._v("ISF Filed")]) : (row3.item.portLocationType == 'USA' && row3.item.amsTime) ? _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("\n              ISF on " + _vm._s(row3.item.isfTime) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "eta_details",
      fn: function(row321) {
        return [(row321.item.ETA_destination_estimated != '') ? _c('span', [_vm._v("Tentative : " + _vm._s(row321.item.ETA_destination_estimated))]) : _vm._e(), _vm._v(" "), (row321.item.ETA_destination_actual != '') ? _c('span', [_c('br'), _vm._v("\n              Actual : " + _vm._s(row321.item.ETA_destination_actual) + "\n            ")]) : _vm._e()]
      }
    }, {
      key: "manifestation",
      fn: function(row3) {
        return [(row3.item.CountmainManifestationData <= 0) ? _c('span', [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          }
        }, [_vm._v("Pending")])], 1) : (row3.item.CountmainManifestationData > 0) ? _c('span', {
          attrs: {
            "variant": "success"
          }
        }, [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.sendMANIFESTATION(row3.item)
            }
          }
        }, [_vm._v("Received")])], 1) : _vm._e(), _vm._v(" "), (row3.item.newManiFestCount > 0) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("New Manifestation " + _vm._s(row3.item.newManiFestCount))]), _c('br')]) : _vm._e()]
      }
    }, {
      key: "closed",
      fn: function(row3) {
        return [(row3.item.closedOverseas_status == 1) ? _c('span', [_c('b-button', {
          staticClass: "mb-1",
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.openCloseOverseasModal(row3.item)
            }
          }
        }, [_vm._v("Close")])], 1) : (row3.item.closedOverseas_status == 0) ? _c('span', {
          attrs: {
            "variant": "success"
          }
        }, [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          }
        }, [_vm._v("Closed")]), _vm._v(" "), _c('br'), _vm._v("\n              User:" + _vm._s(row3.item.closedOverseas_byuser) + "\n              "), _c('br'), _vm._v("\n              Date:" + _vm._s(row3.item.closedOverseas_created_at) + "\n            ")], 1) : _vm._e(), _vm._v(" "), _vm._l((row3.item.NoteDetails), function(CDitem, CD_index) {
          return _c('span', {
            key: CD_index
          }, [(
            _vm.$sessionsStorage.get('designation') == 'Admin' &&
            _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' &&
            CDitem.noteSeries
          ) ? _c('EditCRDRNote', {
            attrs: {
              "title": 'Edit ' +
                (CDitem.creditDebitNoteType === '2' ? 'Debit' : 'Credit') +
                ' Note : ' +
                CDitem.noteSeries,
              "note_id": CDitem.note_id,
              "noteSeries": CDitem.noteSeries,
              "note_page": CDitem.page,
              "AgentType": CDitem.agentType,
              "creditDebitNoteType": CDitem.creditDebitNoteType,
              "approvalStatus": CDitem.approvalStatus,
              "uploadCreditDebit": CDitem.uploadCreditDebit,
              "creditDebitNote_Status": CDitem.creditDebitNote_Status,
              "JOBID": row3.item.allModuleId,
              "JOBNO": row3.item.ffExportFclConsoSeries,
              "JOBDATE": row3.item.loginTime,
              "JOBTYPE": row3.item.jobType
            }
          }) : _vm._e()], 1)
        }), _vm._v(" "), (row3.item.closedOverseas_status == '0') ? _c('CommonOverseaUnLock', {
          attrs: {
            "title": 'Open Overseas FCL Consolidation Assignment',
            "Overlock_item": row3.item,
            "Overlock_JOBNO": row3.item.ffExportFclConsoSeries,
            "Overlock_allModuleId": row3.item.allModuleId,
            "Overlock_table_name": 'frght_fclconsolidationexport',
            "Overlock_table_key": 'ffFclConsoExportId',
            "Overlock_table_value": row3.item.ffFclConsoExportId,
            "Overlock_column_key": 'closedOverseas_status',
            "Overlock_column_value": row3.item.closedOverseas_status,
            "Overlock_module_type": 'Overseas FCL Consolidation Freight Forwarding'
          }
        }) : _vm._e(), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row3.item.allModuleId,
            "fk_client_id": row3.item.clientId,
            "fk_pod_id": row3.item.PODLocationId
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "id": "doc",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-lock-conf",
    attrs: {
      "id": "modal-lock-conf",
      "title": "Reason for Open Locked Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.lockReason),
      callback: function($$v) {
        _vm.lockReason = $$v
      },
      expression: "lockReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeLockUnLockConfirm
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lockReason) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.lock_button ? true : false,
      "variant": "success"
    },
    on: {
      "click": _vm.ConfLock
    }
  }, [_vm._v("Send")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "CloseOverseas-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "md",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h3', [_vm._v("Are you sure to want close")])]), _vm._v(" "), _c('center', [_c('span', {
    staticClass: "center"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.SaveCloseOverseas
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideCloseOverseasModal
    }
  }, [_vm._v("No")])], 1)])], 1), _vm._v(" "), _c('b-modal', {
    ref: "note-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.noteModal.creditDebitNoteType == '1' ?
        'CREDIT NOTE - ' + _vm.noteModal.ffExportFclConsoSeries :
        'DEBIT NOTE - ' + _vm.noteModal.ffExportFclConsoSeries
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h4', {
    staticClass: "error"
  }, [_vm._v("\n        " + _vm._s(_vm.noteModal.approvalStatus == "1" ?
    "Approved" :
    _vm.noteModal.sentForApproval == "1" ?
    "Sent for approval" :
    "") + "\n      ")])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [(_vm.noteModal.uploadCreditDebit != '' && _vm.noteModal.approvalStatus == '1') ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.PrintNote(_vm.noteModal.uploadCreditDebit)
      }
    }
  }, [_vm._v("PDF")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("\n          Add Particulars\n          "), _c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [(_vm.noteModal.creditcount >= 1 && _vm.noteModal.creditDebitNoteType == '1') ? _c('span', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Credit Note No. :")]), _vm._v("\n          " + _vm._s(_vm.noteModal.creditnoteSeriesDetailsCount) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.noteModal.debitcount >= 1 && _vm.noteModal.creditDebitNoteType == '2') ? _c('span', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Debit Note No. :")]), _vm._v("\n          " + _vm._s(_vm.noteModal.debitnoteSeriesDetailsCount) + "\n        ")]) : _vm._e()])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Type "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.agentTypeList,
      "option-value": "TypeVal",
      "option-text": "TypeTxt",
      "placeholder": "Select Type"
    },
    on: {
      "input": function($event) {
        _vm.getAgentConsigneeList(_vm.noteModal.agentType)
      }
    },
    model: {
      value: (_vm.noteModal.agentType),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "agentType", $$v)
      },
      expression: "noteModal.agentType"
    }
  }), _vm._v(" "), (!_vm.noteModal.agentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.agentType))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          To\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getAllAgentColoaderList,
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": _vm.noteModal.agentType == 'Consignee' ?
        'Select Consignee' :
        'Select Agent/Coloader'
    },
    on: {
      "input": _vm.getConsigneeAgentDetails
    },
    model: {
      value: (_vm.noteModal.AgentColoader),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "AgentColoader", $$v)
      },
      expression: "noteModal.AgentColoader"
    }
  }), _vm._v(" "), (!_vm.noteModal.AgentColoader) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCDNote.AgentColoader) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.noteModal.agentType == 'Consignee') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Consignee Address"
    }
  }, [_vm._v("\n          Consignee Address\n          "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Consignee Address"
    },
    model: {
      value: (_vm.noteModal.agentconsigneeAddress),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "agentconsigneeAddress", $$v)
      },
      expression: "noteModal.agentconsigneeAddress"
    }
  }), _vm._v(" "), (!_vm.noteModal.agentconsigneeAddress) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.agentconsigneeAddress))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.noteModal.agentType == 'Agent') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Agent Country"
    }
  }, [_vm._v("\n          Agent Country\n          "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Agent Country"
    },
    model: {
      value: (_vm.noteModal.agent_country),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "agent_country", $$v)
      },
      expression: "noteModal.agent_country"
    }
  }), _vm._v(" "), (!_vm.noteModal.agent_country) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.agent_country))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Vessel/Voy"
    }
  }, [_vm._v("\n          Vessel/Voy\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Vessel Voy"
    },
    model: {
      value: (_vm.noteModal.vesselVoy),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "vesselVoy", $$v)
      },
      expression: "noteModal.vesselVoy"
    }
  }), _vm._v(" "), (!_vm.noteModal.vesselVoy) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.vesselVoy))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "HBL/AWB"
    }
  }, [_vm._v("\n          HBL/AWB\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter HBL/AWB"
    },
    model: {
      value: (_vm.noteModal.BLNumber),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "BLNumber", $$v)
      },
      expression: "noteModal.BLNumber"
    }
  }), _vm._v(" "), (!_vm.noteModal.BLNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.BLNumber))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "MBL/MAWB"
    }
  }, [_vm._v("\n          MBL/MAWB\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter MBL/MAWB"
    },
    model: {
      value: (_vm.noteModal.masterorLinerBlNo),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "masterorLinerBlNo", $$v)
      },
      expression: "noteModal.masterorLinerBlNo"
    }
  }), _vm._v(" "), (!_vm.noteModal.masterorLinerBlNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.masterorLinerBlNo))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "SHIPPER"
    }
  }, [_vm._v("\n          SHIPPER\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter SHIPPER"
    },
    model: {
      value: (_vm.noteModal.clientNameM),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "clientNameM", $$v)
      },
      expression: "noteModal.clientNameM"
    }
  }), _vm._v(" "), (!_vm.noteModal.clientNameM) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.clientNameM))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "CONSIGNEE"
    }
  }, [_vm._v("\n          CONSIGNEE\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter CONSIGNEE"
    },
    model: {
      value: (_vm.noteModal.consignee),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "consignee", $$v)
      },
      expression: "noteModal.consignee"
    }
  }), _vm._v(" "), (!_vm.noteModal.consignee) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.consignee))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Destination"
    }
  }, [_vm._v("\n          Destination\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Destination"
    },
    model: {
      value: (_vm.noteModal.FinalPlace),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "FinalPlace", $$v)
      },
      expression: "noteModal.FinalPlace"
    }
  }), _vm._v(" "), (!_vm.noteModal.FinalPlace) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.FinalPlace))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Container No"
    }
  }, [_vm._v("\n          Container No.\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Container No"
    },
    model: {
      value: (_vm.noteModal.containerNoArryNote),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "containerNoArryNote", $$v)
      },
      expression: "noteModal.containerNoArryNote"
    }
  }), _vm._v(" "), (!_vm.noteModal.containerNoArryNote) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.containerNoArryNote))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Container Type"
    }
  }, [_vm._v("\n          Container Type\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Container Type."
    },
    model: {
      value: (_vm.noteModal.containersTypes),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "containersTypes", $$v)
      },
      expression: "noteModal.containersTypes"
    }
  }), _vm._v(" "), (!_vm.noteModal.containersTypes) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.containersTypes))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "SHIPPER INV."
    }
  }, [_vm._v("\n          SHIPPER INV.\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter SHIPPER INV. Details"
    },
    model: {
      value: (_vm.noteModal.ShipperInvDet),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "ShipperInvDet", $$v)
      },
      expression: "noteModal.ShipperInvDet"
    }
  }), _vm._v(" "), (!_vm.noteModal.ShipperInvDet) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.ShipperInvDet))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Booking No"
    }
  }, [_vm._v("\n          Booking No\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Booking No"
    },
    model: {
      value: (_vm.noteModal.validBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "validBookingNo", $$v)
      },
      expression: "noteModal.validBookingNo"
    }
  }), _vm._v(" "), (!_vm.noteModal.validBookingNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.validBookingNo))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "SOB"
    }
  }, [_vm._v("\n          SOB\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "SOB",
      "minute-step": 1,
      "name": "SOB"
    },
    model: {
      value: (_vm.noteModal.SOB),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "SOB", $$v)
      },
      expression: "noteModal.SOB"
    }
  }), _vm._v(" "), (!_vm.noteModal.SOB) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.SOB))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "ETADest"
    }
  }, [_vm._v("\n          ETA Dest\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "ETADest",
      "minute-step": 1,
      "name": "ETADest"
    },
    model: {
      value: (_vm.noteModal.ETADest),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "ETADest", $$v)
      },
      expression: "noteModal.ETADest"
    }
  }), _vm._v(" "), (!_vm.noteModal.ETADest) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.ETADest))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(_vm.noteParticulars.length > 0) ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("QTY")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Final")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Selected Cont")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Currecny")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Actions")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.noteParticulars), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "Enter Particular"
      },
      model: {
        value: (item.parti),
        callback: function($$v) {
          _vm.$set(item, "parti", $$v)
        },
        expression: "item.parti"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "Enter Quantity"
      },
      on: {
        "input": _vm.TotalAMT
      },
      model: {
        value: (item.qty),
        callback: function($$v) {
          _vm.$set(item, "qty", $$v)
        },
        expression: "item.qty"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Amount"
      },
      on: {
        "keyup": _vm.TotalAMT
      },
      model: {
        value: (item.amt),
        callback: function($$v) {
          _vm.$set(item, "amt", $$v)
        },
        expression: "item.amt"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.final_amt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.container_selected))]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.CurrencyList,
        "option-value": "currency_id",
        "option-text": "currencyCode",
        "placeholder": "Select Currency"
      },
      model: {
        value: (item.currency),
        callback: function($$v) {
          _vm.$set(item, "currency", $$v)
        },
        expression: "item.currency"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeParti(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), _vm._v(" "), (_vm.TotAMT != 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.TotAMT))])])]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "3"
    },
    model: {
      value: (_vm.noteModal.remarks),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "remarks", $$v)
      },
      expression: "noteModal.remarks"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "10"
    }
  }, [(_vm.noteParticulars.length > 0 && _vm.noteModal.AgentColoader) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.IsCDNotedisabled,
      "variant": "success"
    },
    on: {
      "click": _vm.submitNote
    }
  }, [_vm._v("Send for approval")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideNoteModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9932598","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/overSeasFclCon.vue
// module id = 2829
// module chunks = 0